<ng-container *transloco="let t">

  <div class="row mt-3">
    <div class="col-12">
      <h3 class="text-secondary mb-2">
        <lucide-icon [img]="icons.calendar"></lucide-icon>
        Planification
      </h3>

      @if (activeSchedules().length === 0) {
        <p>
          Aucune planification à afficher.
        </p>
      }

      <ul class="list-group list-group-flush mt-1">
        @for (schedule of sortedSchedules(); track schedule.id) {
          <li class="list-group-item schedule px-0">
            <app-schedule-display
              [activity]="activity()"
              [schedule]="schedule">
            </app-schedule-display>
          </li>
        }
      </ul>

    </div>
  </div>
</ng-container>
